import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import { TTransferPricingPeriodSelection } from '../transfer-pricing/policy/types';
import { RootfiAccountMapping } from './types';

export function useAccountMappings(
  companyId: number,
  period?: TTransferPricingPeriodSelection
) {
  const queryString = new URLSearchParams();

  if (companyId) {
    queryString.append('companyId', companyId.toString());
  }

  if (period?.periodStart && (period.periodType || period.periodEnd)) {
    queryString.append('periodStart', period.periodStart);

    if (period.periodType) {
      queryString.append('periodType', period.periodType);
    } else if (period.periodEnd) {
      queryString.append('periodEnd', period.periodEnd);
    }
  }

  const URL = companyId
    ? `transfer-pricing/account-mapping?${queryString.toString()}`
    : null;

  const {
    data,
    error,
    mutate,
    isLoading,
  }: {
    data?: {
      accountMappings: RootfiAccountMapping[];
      count: number;
    };
    error: unknown;
    mutate: KeyedMutator<unknown>;
    isLoading: boolean;
  } = useSWR(
    URL,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data,
    error,
    mutate,
    isLoading,
  };
}
